import React from 'react';
import { Box, Grid, Skeleton, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StyledQuestion } from './index.style';
import AnswerItem from './AnswerItem';

const Question = ({
  titleQuestion,
  subOption,
  answers,
  onSelected,
  answersSelected,
  valueTextOther,
  handleChangeTextOther,
  hasInputOther,
}) => {
  const { t } = useTranslation();

  const handleClickItem = (answer) => {
    if (onSelected) onSelected(answer);
  };
  const handleChangeValue = (e) => handleChangeTextOther(e.target.value);

  return (
    <StyledQuestion>
      <Box className="container-question">
        <Typography className="title-question">{titleQuestion}</Typography>
        <Typography className="title-sub-option">{subOption}</Typography>
      </Box>
      <Box className="container-answer">
        {answers?.length > 0 ? (
          <Grid container columnSpacing={2}>
            <Grid container spacing={2} item>
              {answers?.map((answer) => (
                <Grid item xs={12} sm={6} md={4} lg={4} xl={4} key={answer.key}>
                  <AnswerItem
                    onSelect={handleClickItem}
                    selected={answersSelected?.some(
                      (item) => answer?.key === item?.key,
                    )}
                    answer={answer}
                  />
                </Grid>
              ))}
            </Grid>
            {hasInputOther && (
              <Grid spacing={2} item xs={12} sm={6} md={4} lg={4} xl={4}>
                <input
                  className="input-other"
                  placeholder={t('enterOwnAnswer')}
                  value={valueTextOther}
                  onChange={handleChangeValue}
                />
              </Grid>
            )}
          </Grid>
        ) : (
          <Grid container spacing={2}>
            {[...Array(8).keys()]?.map((answer) => (
              <Grid item xs={12} sm={6} md={4} lg={4} xl={4} key={answer.key}>
                <div className="container-skeleton-survey">
                  <Skeleton
                    animation="wave"
                    className="skeleton-survey"
                    variant="circular"
                    width={24}
                    height={24}
                  />
                  <div style={{ width: '100%' }}>
                    <Skeleton
                      animation="wave"
                      height={10}
                      width="100%"
                      className="skeleton-survey"
                      style={{ marginBottom: 6 }}
                    />
                    <Skeleton
                      animation="wave"
                      height={10}
                      width="70%"
                      className="skeleton-survey"
                      style={{ marginBottom: 6 }}
                    />
                  </div>
                </div>
              </Grid>
            ))}
          </Grid>
        )}
      </Box>
    </StyledQuestion>
  );
};

export default Question;
